import { Icon } from '@pella/sash-framework';
import React from 'react';
import { DAYS, MONTHS } from '../../../utilities/constants';
import PropTypes from 'prop-types';
import Logo from '../../logo';
import { formatPhoneNumber } from '../../../utilities/functions';

const FifteenMinuteApptScheduled = ({ consultationState, salesBio, view }) => {
	const { startDate, firstName, timezoneShortCode, phoneNumber } = consultationState.data.createAppointment;
	let appointmentDate = null,
		appointmentTime = null,
		appointmentTimeEnd = null,
		period = null;

	setTimeout(() => {
		document.getElementById('appointmentTop')?.scrollIntoView();
	}, '100');

	if (startDate) {
		const weekday = new Date(startDate).getDay();
		const splitDate = startDate?.split('T');
		const day = parseInt(splitDate[0]?.split('-')[2]);
		const monthNumber = splitDate[0]?.split('-')[1];
		const year = splitDate[0]?.split('-')[0];
		const hour = parseInt(splitDate[1]?.split(':')[0]) > 12 ? parseInt(splitDate[1]?.split(':')[0]) - 12 : parseInt(splitDate[1]?.split(':')[0]);
		const minute = splitDate[1]?.split(':')[1];
		period = parseInt(splitDate[1]?.split(':')[0]) >= 12 ? 'PM' : 'AM';

		const appointmentDuration = 15;
		const appointmentDurationRemainder = 60 - appointmentDuration;
		const appointmentEndHour = minute >= appointmentDurationRemainder ? Number(hour) + 1 : hour;
		const appointmentEndMinute = minute >= appointmentDurationRemainder ? minute - appointmentDurationRemainder : Number(minute) + appointmentDuration;

		appointmentDate = `${DAYS[weekday]}, ${MONTHS[monthNumber - 1]} ${day}, ${year}`;
		appointmentTime = `${hour}:${minute}`;
		appointmentTimeEnd = `${Number(appointmentEndHour) > 12 ? Number(appointmentEndHour) - 12 : appointmentEndHour}:${String(appointmentEndMinute).padStart(2, '0')}`;
	}

	return (
		<div
			id='appointmentTop'
			className={`${view === 'rta' ? 'mx-auto' : ''} my-6 flex w-full max-w-[908px] flex-col justify-center border border-gray-42 bg-white px-6 pb-14 pt-10 md:my-8 md:px-[84px] md:py-14 xl:my-10 xl:px-[186px]`}
		>
			<Logo className='mb-5 h-[88px]' />
			<h2 className='mb-4 text-center'>Your Call has Been Scheduled</h2>
			<p className='text-subtitle text-center md:text-left'>Thanks {firstName}, a calendar invitation has been sent to your email address.</p>
			<h3 className='text-subtitle-2 mb-4 mt-8 bg-gray-5 p-3'>Call Details</h3>
			<div className='mb-8 ml-4 flex'>
				<Icon
					name='person'
					className='mr-3 text-black'
				/>
				<p>
					<span className='text-black'>{salesBio?.title}</span> will be calling <span className='text-black'>{formatPhoneNumber(phoneNumber)}</span>
				</p>
			</div>
			<div className='ml-4 flex'>
				<Icon
					name='calendar_month'
					className='mr-3 text-black'
				/>
				<div>
					<p>{appointmentDate}</p>
					<p className='m-0'>
						{appointmentTime} - {appointmentTimeEnd} {period} {timezoneShortCode}
					</p>
				</div>
			</div>
		</div>
	);
};

FifteenMinuteApptScheduled.propTypes = {
	consultationState: PropTypes.object,
	salesBio: PropTypes.object,
	view: PropTypes.string,
};

export default FifteenMinuteApptScheduled;
